import {InjectionToken} from '@angular/core';
import { Observable, of } from 'rxjs';

export interface DataRequirements {
  getDiscountInfo(code): Observable<any>;
}

export const DataRequirementsInjectionToken = new InjectionToken<DataRequirements>('code-verification Data Requirements')
